import { gql } from '@apollo/client'
import { useDocument } from '@ztechapps/common.hook'
import { useUser } from './useUser'

const documentFragment = gql`
  fragment customerDefaultFragment on Customer {
    _id
    status
    profile {
      _id
      name
      picture
      email
    }
    timeZone
    phone
    company {
      _id
      name
    }
    address {
      _id
      street1
      street2
      city
      state
      zip
      fullAddress
      country
    }
  }
`

const getMyCustomerQuery = gql`
  ${documentFragment}
  query getMyCustomer($filter: JSON) {
    getMyCustomer(filter: $filter) {
      ...customerDefaultFragment
    }
  }
`

export const useCustomer = () => {
  const { user } = useUser()
  const _id = user?._id
  const customerDocument = useDocument({
    query: getMyCustomerQuery,
    filter: {},
    options: { queryOptions: { skip: !_id } },
  })

  return customerDocument
}
